/* eslint-disable max-lines */
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import {
  useI18n,
  TypeIcon,
  LivingSpaceIcon,
  VolumeIcon,
  ConstructionYearIcon,
  PieceIcon,
  BathroomIcon,
  ParkingIcon,
  GagrageIcon,
  EtatIcon,
  BalconIcon,
  TerrasseIcon,
  RenovYearIcon,
} from '@popety_io/popety-io-lib'
import IconButton from '@mui/material/IconButton'
import { useSelector } from 'react-redux'
import {
  estimateSelector,
  estimateDefaultValue,
  estimatedEditedSelector,
} from '../../redux'

const EstimationDetails = () => {
  const { t } = useI18n()
  const estimate = useSelector(estimateSelector)
  const defaultValueEstimate = useSelector(estimateDefaultValue)
  const estimateEdited = useSelector(estimatedEditedSelector)

  const data1 = [
    {
      label: t('common.type'),
      name: 'type',
      value: t(
        `common.${estimateEdited?.type || estimate?.type || 'apartment'}`,
      ),
      icon: (
        <TypeIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
    {
      label: t('financial.Surface habitable'),
      name: 'area',
      value: estimateEdited?.area || estimate?.area || '-',
      endAdornment: estimateEdited?.area || estimate?.area ? ' m2' : '',
      icon: (
        <LivingSpaceIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
    {
      label: t('common.rooms'),
      name: 'rooms',
      value: estimateEdited?.rooms || estimate?.rooms || '-',
      icon: (
        <PieceIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
    {
      label: t('common.Bathrooms'),
      name: 'baths',
      value: estimate?.baths || defaultValueEstimate?.bathroom_nb || '-',
      icon: (
        <BathroomIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
    {
      label: t('common.landRadarInfo.buildingYear'),
      name: 'contruction_date',
      value:
        estimateEdited?.construction_date || estimate?.construction_date || '-',
      icon: (
        <ConstructionYearIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
  ]

  const data2 = [
    {
      name: 'land_area',
      label: t('common.search.details.Land area'),
      value: estimateEdited?.land_area || estimate?.land_area || '-',
      endAdornment:
        estimateEdited?.land_area || estimate?.land_area ? ' m2' : '',
      icon: (
        <LivingSpaceIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
    {
      label: t('building.info.Volume'),
      name: 'volume',
      value: estimateEdited?.volume || estimate?.volume || '-',
      endAdornment: estimateEdited?.volume && ' m3',
      icon: (
        <VolumeIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
    {
      name: 'balcon',
      label: t('common.Balcon'),
      value: estimateEdited?.balcon || estimate?.balcon || '-',
      endAdornment: estimateEdited?.balcon || estimate?.balcon ? ' m2' : '',
      icon: (
        <BalconIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
    {
      name: 'terrasse',
      label: t('common.Terrasse'),
      value: estimateEdited?.terrasse || estimate?.terrasse || '-',
      endAdornment: estimateEdited?.terrasse || estimate?.terrasse ? ' m2' : '',
      icon: (
        <TerrasseIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
    {
      name: 'weightedLivingArea',
      label: t('common.WeightedLivingArea'),
      value:
        estimateEdited?.weightedLivingArea ||
        estimate?.weightedLivingArea ||
        '-',
      endAdornment:
        estimateEdited?.weightedLivingArea || estimate?.weightedLivingArea
          ? ' m2'
          : '',
      icon: (
        <LivingSpaceIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
  ]

  const data3 = [
    {
      name: 'etat',
      label: t('common.Etat'),
      value:
        estimate?.condition || estimateEdited?.condition
          ? t(`common.${estimateEdited?.condition || estimate?.condition}`)
          : '-',
      icon: (
        <EtatIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
    {
      name: 'renovation_year',
      label: t('search.renovationYearSection'),
      value: estimateEdited?.renovation_year || estimate?.renovationYear || '-',
      icon: (
        <RenovYearIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
    {
      label: t('common.Place parking'),
      name: 'parking',
      value: estimateEdited?.parking || estimate?.parking || '-',
      icon: (
        <ParkingIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
    {
      label: t('common.Place garage'),
      name: 'garage',
      value: estimateEdited?.garage || estimate?.garage || '-',
      icon: (
        <GagrageIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
  ]

  return (
    <Box
      sx={{
        marginTop: '20px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingBottom: '10px',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            marginBottom: '4px',
            fontSize: '1.1rem',
            textTransform: 'uppercase',
            color: (theme) => theme.palette.secondary.main,
          }}
        >
          {t('estimate.details du bien')}
        </Typography>
        <IconButton
          aria-label="alarm"
          sx={{
            color: '#969696',
            padding: '0',
          }}
        />
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          {data1.map((item, i) => (
            <Box
              key={i}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '4px',
              }}
            >
              <Grid container spacing={2}>
                <Grid item sm={7}>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '10px',
                      color: '#969696',
                      fontSize: '0.9rem',
                    }}
                  >
                    {item.icon}
                    <Typography
                      fontWeight="500"
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: '1',
                        WebkitBoxOrient: 'vertical',
                      }}
                    >
                      {item.label}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item sm={5}>
                  <Typography
                    fontWeight="500"
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: '1',
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {item.value}
                    {item?.value && item?.endAdornment ? item.endAdornment : ''}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          ))}
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          {data2.map((item, i) => (
            <Box
              key={i}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '4px',
              }}
            >
              <Grid container spacing={2}>
                <Grid item sm={7}>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '10px',
                      color: '#969696',
                    }}
                  >
                    {item.icon}
                    <Typography
                      fontWeight="500"
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: '1',
                        WebkitBoxOrient: 'vertical',
                      }}
                    >
                      {item.label}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item sm={5}>
                  <Typography
                    fontWeight="500"
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: '1',
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {item.value}
                    {item?.value && item?.endAdornment ? item.endAdornment : ''}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          ))}
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          {data3.map((item, i) => (
            <Box
              key={i}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '4px',
              }}
            >
              <Grid container spacing={2}>
                <Grid item sm={7}>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '10px',
                      color: '#969696',
                    }}
                  >
                    {item.icon}
                    <Typography
                      fontWeight="500"
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: '1',
                        WebkitBoxOrient: 'vertical',
                      }}
                    >
                      {item.label}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item sm={5}>
                  <Typography
                    fontWeight="500"
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: '1',
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {item.value}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  )
}

export default EstimationDetails
